import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import { ContentContainer, ContentCircularLoader } from '@libComponents';

import ManageViewSwitcher from './ManageViewSwitcher';
import { useManageViewSwitcher } from './hooks';
import { getAllEmployeeEnhancedSelector } from 'common/redux.selectors';
import { DOMAIN_NAME as COMMON_DOMAIN } from 'common/common';
import { GET_ALL_EMPLOYEE_NAME_EMAIL } from 'common/redux.datasets';
import { fetchDatasets } from '@libs/datasets';

const propTypes = {
    ContentComponent: PropTypes.elementType.isRequired,
    title: PropTypes.string,
    loading: PropTypes.bool
};

const StyledBox = styled(Box)({
    position: 'relative'
});

const ManageContainer = ({ ContentComponent, loading }) => {
    const { state } = useLocation();
    const RXDispatch = useDispatch();
    const { email } = state || {};

    // Get all employees to find current employee name
    const allEmployees = useSelector((state) =>
        getAllEmployeeEnhancedSelector(
            state,
            COMMON_DOMAIN,
            GET_ALL_EMPLOYEE_NAME_EMAIL
        )
    );

    // Get current employee name
    const currentEmployee =
        allEmployees.find((emp) => emp.email === email) || null;
    const employeeName = currentEmployee
        ? `${currentEmployee.firstname || ''} ${
              currentEmployee.middlename || ''
          } ${currentEmployee.lastname || ''}`.trim()
        : '';

    useEffect(() => {
        if (email) {
            RXDispatch(fetchDatasets(GET_ALL_EMPLOYEE_NAME_EMAIL));
        }
    }, [email, RXDispatch]);

    const { viewType, handleManageViewChange, selectedManageView } =
        useManageViewSwitcher(employeeName);

    return (
        <StyledBox>
            {loading && <ContentCircularLoader />}
            <ContentContainer
                title={selectedManageView}
                headerBg='transparent'
                AdornmentComponent={
                    <ManageViewSwitcher
                        selectedView={viewType}
                        onViewChange={handleManageViewChange}
                    />
                }
            >
                <ContentComponent currentView={viewType} />
            </ContentContainer>
        </StyledBox>
    );
};

ManageContainer.propTypes = propTypes;

export { ManageContainer as default, ManageContainer };
